import { z } from "zod";

export const KnowledgeBaseFaqItemSchema = z.object({
  Id: z.string().optional(),
});

export type KnowledgeBaseFaqItemType = z.infer<
  typeof KnowledgeBaseFaqItemSchema
>;
